// Sent on every authenticated tRPC batch so the captureTimezone server
// middleware can record the user's local zone (ENG-148). Skipped during SSR.
export function getClientTimezoneHeader(): Record<string, string> {
  if (typeof window === "undefined") {
    return {};
  }
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz ? { "x-tz": tz } : {};
  } catch {
    return {};
  }
}
